import { Typography } from '@mui/material'
import { ReactNode } from 'react'

export const LabelBox = ({ first, second }: { first?: ReactNode; second?: ReactNode }) => (
  <>
    {first !== undefined && (
      <Typography fontWeight={500} color="grey.900" variant="body2">
        {first}
      </Typography>
    )}
    {second !== undefined && (
      <Typography display="block" fontWeight={400} color="grey.600" variant="body2">
        {second}
      </Typography>
    )}
  </>
)
